import { Room } from 'matrix-js-sdk/src';
import moment from 'moment';

import { ScheduledDate } from 'utils/types';

import { UnitsEnum } from '../AutoRemindersStepModal/utils';

export type Reminder = {
  amount?: number;
  unit: UnitsEnum;
  enabled: boolean;
  isCustom: boolean;
};

export type RoomFormType = {
  roomName: string;
  roomAlias: string;
  isWaitingListEnabled: boolean;
  isPrivateRoom: boolean;
  participants: string[];
  reminders: Reminder[];
  startDate?: Date;
  startTime?: Date;
  endDate?: Date;
  endTime?: Date;
  timeZone: number;
  description?: string;
  participantInput?: string;
  invitationMessage?: string;
};

export const extractAliasAsPath = (alias: string) => alias.slice(1).split(':')[0];
export const extractAlias = (alias: string) => extractAliasAsPath(alias).split('-').slice(0, -1).join('-');
export const getAndExtractAlias = (room?: Room) => {
  const fullAlias = room?.getCanonicalAlias();
  if (fullAlias) return extractAlias(fullAlias);
};

export const getDigitsFromRoomAlias = (room?: Room) => {
  const fullAlias = room?.getCanonicalAlias();
  if (fullAlias) return extractAliasAsPath(fullAlias).split('-').at(-1);
};

export const getRandomFourDigitString = () => String(Math.floor(Math.random() * 10000)).padStart(4, '0');

type RoomMetadata = {
  description: string | null;
  scheduledToStartAt: ScheduledDate;
  scheduledToEndAt: ScheduledDate;
};

export const getStartEndDate = (isSchedulingAvailable: boolean, metadata?: RoomMetadata) => {
  const getInitialDate = (date?: ScheduledDate) => {
    if (!date || !isSchedulingAvailable) return undefined;

    const m = moment.parseZone(date);
    // NOTE: ignoring the timezone
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
  };

  const initialStartAt = getInitialDate(metadata?.scheduledToStartAt);
  const initialEndAt = getInitialDate(metadata?.scheduledToEndAt);

  return { initialStartAt, initialEndAt };
};

export enum AliasStatusEnum {
  UNKNOWN = 'unknown',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
}

export const currentTimeZoneOffset = -new Date().getTimezoneOffset() / 60;

export const extractTimeZone = (isoWithZone: Date | string) => {
  const m = moment.parseZone(isoWithZone);
  return m.utcOffset() / 60;
};

const defaultReminderProps = { enabled: false, isCustom: false };
export const defaultReminders: Reminder[] = [
  { amount: 5, unit: UnitsEnum.MINUTES, ...defaultReminderProps },
  { amount: 10, unit: UnitsEnum.MINUTES, ...defaultReminderProps },
  { amount: 15, unit: UnitsEnum.MINUTES, ...defaultReminderProps },
  { amount: 30, unit: UnitsEnum.MINUTES, ...defaultReminderProps },
  { amount: 1, unit: UnitsEnum.HOURS, ...defaultReminderProps },
  { amount: 1, unit: UnitsEnum.DAYS, ...defaultReminderProps },
];
